import { formatProjectDate, formatSubmittedDateTime } from "./dateFormat";

export const alwaysDisabledFields: string[] = [
  "RITM_number",
  "project_id",
  "is_address_business_problem",
  "is_internal_team_address_business_problem",
  "is_external_scope",
  "is_proceed_further",
  "requested_by",
  "location",
  "request_manager",
  "email",
  "project_lead_name",
  "business_stack_req_group",
  "finance_lead_name",
  "finance_lead_email",
  "cost_center",
  "sector",
  "geo_graphic_scope",
  "is_new_consulting_project",
  "project_name",
  "project_brief",
  "consulting_type",
  "estimated_project_start_date",
  "estimated_project_end_date",
  "is_consulting_work",
  "preferred_vendor",
  "core_deliverables",
  "project_budget",
  "is_follow_up",
];

export const conditionalDisabledFieldsEdit: string[] = [
  "consulting_company",
  "final_total_cost",
  "project_core_deliverables",
  "rate_value_received",
  "purchase_order_number",
  "close_out_additional_phase",
];

export const conditionalDisabledFieldsIntakeEdit: string[] = [
  "project_id",
  "project_name",
  "project_brief",
  "project_lead_name",
  "project_lead_email",
  "business_stack_req_group",
  "sector",
  "consulting_type",
  "estimated_project_start_date",
  "estimated_project_end_date",
  "consulting_company",
  "core_deliverables",
  "final_total_cost",
  "rate_value_received",
];

export const documentclassification = {
  confidential: 1,
  restricted: 2,
  internal: 3,
  confidentialCatergory: "confidential",
  restrictedCategory: "restricted",
  internalCategory: "internal",
  Yes: "yes",
};
export const IntakeMadatoryFields = [
  "project_name",
  "project_lead_email",
  "project_lead_name",
  "business_stack_req_group",
  "sector",
  "consulting_type",
  "consulting_company",
];
export const IntakefieldNameMapping: { [key: string]: string } = {
  project_name: "Project Name",
  project_lead_email: "Project Lead Email",
  project_lead_name: "Project Lead Name",
  business_stack_req_group: "Business Stakeholder",
  sector: "Sector",
  consulting_type: "Consulting Type",
  consulting_company: "Vendor Company",
};
export const closeoutRequiredFields = [
  "consultingCompany",
  "finalCost",
  "coreDeliverables",
  "rating",
];

export const closeoutFieldNameMapping: { [key: string]: string } = {
  consultingCompany: "Consulting Company",
  finalCost: "Final Cost",
  coreDeliverables: "Core Deliverables",
  rating: "Rating",
};
export const Prefix = {
  RITM: "RITM",
};

export const snowFields = [
  { label: "Snow ID", key: "snow_id" },
  { label: "Location", key: "location" },
  { label: "Requested Manager", key: "requested_manager" },
  { label: "Is consulting work", key: "is_consulting_work" },
  { label: "Is proceed further", key: "is_proceed_further" },
  { label: "Business stack req group", key: "business_stack_req_group" },
  { label: "Consulting type", key: "consulting_type" },
  { label: "Cost center", key: "cost_center" },
  { label: "Is follow up", key: "is_follow_up" },
  {
    label: "Estimated project end date",
    key: "estimated_project_end_date",
    formatter: formatProjectDate,
  },
  {
    label: "Estimated project start date",
    key: "estimated_project_start_date",
    formatter: formatProjectDate,
  },
  { label: "Is external scope", key: "is_external_scope" },
  { label: "Finance lead email", key: "finance_lead_email" },
  { label: "Finance lead name", key: "finance_lead_name" },
  { label: "Geographic scope", key: "geo_graphic_scope" },
  { label: "Is address business problem", key: "is_address_business_problem" },
  { label: "Is new consulting project", key: "is_new_consulting_project" },
  { label: "Project budget", key: "project_budget" },
  { label: "Preferred vendor", key: "preferred_vendor" },
  { label: "Project brief", key: "project_brief", convert: "convert" },
  { label: "Project lead name", key: "project_lead_name" },
  { label: "Project name", key: "project_name" },
  {
    label: "Is internal team address problem",
    key: "is_internal_team_address_business_problem",
  },
  { label: "Sector", key: "sector" },
  { label: "Core deliverables", key: "core_deliverables", convert: "convert" },
  {
    label: "Load time",
    key: "load_timestamp",
    formatter: formatSubmittedDateTime,
  },
];
export const ticketDetails = [
  { label: "RITM Number", key: "Number" },
  { label: "Request", key: "request" },
  { label: "Assignment Group", key: "assignment_group" },
  { label: "Stage", key: "stage" },
  { label: "State", key: "state" },
  { label: "Closed By", key: "closed_by" },
  { label: "Requested By", key: "requested_by" },
  { label: "Email", key: "email" },
  { label: "Created Date", key: "created_date", formatter: formatProjectDate },
  { label: "Closed Date", key: "closed", formatter: formatProjectDate },
];
export const rerunLImit = 4;
export const feedbackTypes = {
  goodResponse: 1,
  badResponse: 2,
  reRunResponse: 3,
};
export const navigationUrls = {
  consultingIntake: "Consulting Intake",
  userGuidelines: "How to Use",
  ConsultingSearch: "Consulting Search",
};

export const dropdownfeedbackOptions = [
  { id: "1", displayText: "Latency" },
  { id: "2", displayText: "Response was not relevant" },
  { id: "3", displayText: "Inaccurate response" },
  { id: "5", displayText: "Other" },
];
export const OthertypeFeedbackId = "5";
export const validRoutes = [
  "/",
  "/spend-wise-hub",
  "/spend-wise-hub/chat-assistant",
  "/spend-wise-hub/upload-engagement_data",
  "/spend-wise-hub/engagement-history",
  "/about-chatbot",
  "/user-list",
  "/my-profile",
  "/health",
  "/authorization_code/callback",
];
export const sowfileFormat = ["pdf", "docx"];
export const getfeedback = (rating: number): string => {
  switch (rating) {
    case 1:
      return "Very Dissatisfied";
    case 2:
      return "Dissatisfied";
    case 3:
      return "Somewhat Dissatisfied";
    case 4:
      return "Slightly Dissatisfied";
    case 5:
      return "Neutral";
    case 6:
      return "Slightly Satisfied";
    case 7:
      return "Somewhat Satisfied";
    case 8:
      return "Satisfied";
    case 9:
      return "Very Satisfied";
    case 10:
      return "Extremely Satisfied";
    default:
      return "";
  }
};


export const getBoxColor = (rating: number): string => {
  if (rating <= 6) return "#DD334D";
  if (rating <= 8) return "#FFCC49";
  return "#339D75";
};
